module.exports = __webpack_public_path__ + "static/media/raymond_kao.83e723dd.png";